import type {
  ValidateBankAccountPaymentMethodProp,
  PaymentMethodError,
} from './types/PaymentMethodValidationTypes';
import { isFormattedBankAccountPaymentMethod } from './isFormattedBankAccountPaymentMethod';
import { isFormattedCardPaymentMethod } from './isFormattedCardPaymentMethod';
import validateCardPaymentMethod from './validateCardPaymentMethod';
import validateBankAccountPaymentMethod from './validateBankAccountPaymentMethod';

export type {
  ValidateBankAccountPaymentMethodProp,
  PaymentMethodError,
};

const validatePaymentMethod = ({
  formattedPaymentMethod,
  options,
  noPaymentMethodAvailable,
}: ValidateBankAccountPaymentMethodProp):
  | undefined
  | PaymentMethodError => {
  if (noPaymentMethodAvailable) {
    return {
      errorTitle: 'Please add a payment method.',
    };
  }
  if (!formattedPaymentMethod) {
    return {
      errorTitle: 'Please select a payment method.',
    };
  }

  if (isFormattedCardPaymentMethod(formattedPaymentMethod)) {
    return validateCardPaymentMethod({ formattedPaymentMethod });
  }

  if (
    isFormattedBankAccountPaymentMethod(formattedPaymentMethod)
  ) {
    return validateBankAccountPaymentMethod({
      formattedPaymentMethod,
      options,
    });
  }
  throw new Error(
    'Invalid (or) Unhandled formattedPaymentMethod.type',
  );
};

export default validatePaymentMethod;
